require('../../fhApp/currentUser/currentUser');

'use strict';

angular.module('app.myHockeyTv.myFeed.myFeedController', [
    'app.currentUser'
])
    .controller('app.myHockeyTv.myFeed.myFeedController', [
        '$scope', 'currentUser', '$stateParams',
        function ($scope, currentUser, $stateParams) {
            $scope.currentUser = currentUser;
            $scope.feed_type = $stateParams.type;
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/myFeed/myFeedController.js